import axios from 'axios'
const { VUE_APP_API_URL } = process.env

const loadAllBookings = async (token, data) => {
  const result = { error: false }
  try {
    const res = await axios
      .post(`${VUE_APP_API_URL}/api/v2/getBookingHistory`, {
        bkgnumber: data.bookingNumber,
        name: data.name,
        number: data.number,
        staffbkg: false,
        system: data.system
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

export {
  loadAllBookings
}
